//
// LocalizationContext.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import EventDispatcher from "../../events/EventDispatcher";
import "../../lib";

var LocalizationContext = createModule("commons::LocalizationContext", [], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getFormatterLocale: [7],
        freeze: [6,6],
        getDataLocale: [7],
        setFormatterLocale: [0,7,6],
        setOverride: [0,1],
        getString: [7,7,7,4],
        unfreeze: [2,6],
        getLocale: [7],
        getMutableCopy: [1],
        getSASLogLocale: [7],
        setLocale: [0,7,6],
    },
    ,
    ,
]);
export default LocalizationContext;
